module.exports = __webpack_public_path__ + "img/work-4.71364475.jpg";